import { Navigate } from "react-router-dom";
import AuthGuard from "./AuthGaurd";
import Layout from "../Components/Layout/Layout";
import TrainingForm from "../Components/Forms/TrainingForm";
import ModelsForm from "../Components/Forms/ModelsForm";
import InferenceForm from "../Components/Forms/InferenceForm";
import HowToForm from "../Components/Forms/HowToForm";
import ForecastForm from "../Components/Forms/ForecastForm";
import ErrorBoundaryPage from "../Components/Common/ErrorBoundaryPage";


const routes = [
  {
    path: "/",
    element: (
      <Navigate to="/training" replace />
    ),
    errorElement: <ErrorBoundaryPage />,
  },
  {
    path: "/training",
    element: (
      <AuthGuard>
        <Layout ><TrainingForm/></Layout>
      </AuthGuard>
    ),
    errorElement: <ErrorBoundaryPage />,
  },
  {
    path: "/models",
    element: (
      <AuthGuard>
        <Layout ><ModelsForm/></Layout>
      </AuthGuard>
    ),
    errorElement: <ErrorBoundaryPage />,
  },
  {
    path: "/inference",
    element: (
      <AuthGuard>
        <Layout ><InferenceForm/></Layout>
      </AuthGuard>
    ),
    errorElement: <ErrorBoundaryPage />,
  },
    {
    path: "/forecast",
    element: (
      <AuthGuard>
        <Layout ><ForecastForm/></Layout>
      </AuthGuard>
    ),
    errorElement: <ErrorBoundaryPage />,
  },
  {
    path: "/howto",
    element: (
      <AuthGuard>
        <Layout ><HowToForm/></Layout>
      </AuthGuard>
    ),
    errorElement: <ErrorBoundaryPage />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
    errorElement: <ErrorBoundaryPage />,
  },
];

export default routes;